<div [ngClass]="{'tw-opacity-20': disabled, 'tw-pointer-events-none': disabled}"
     class="tw-transition-opacity tw-ease-in-out tw-duration-200">
  <div class="input-group">
    <input #dpFromDate
           class="form-control"
           placeholder="{{'lang.globals.selectATimespan' | translate}}"
           name="dpFromDate"
           type="text"
           [(ngModel)]="fullDateString"
           (blur)="refreshFromDateString()"
           (keydown.enter)="refreshFromDateString()"
           [ngStyle]="{'border-color':fromDate>toDate ? '#fd397a' : null}">
    <div class="input-group-append tw-cursor-pointer" (click)="toggleDatepicker()">
        <span class="input-group-text h-100">
          <sb-icon icon="calendar"></sb-icon>
        </span>
    </div>
    <div class="datepicker-dropdown">
      <div class="daterangepicker w-100" *ngIf="visible">
        <div class="d-flex flex-row flex-wrap p-2">
          <ngb-datepicker
            name="datepicker"
            #datepicker="ngbDatepicker"
            (dateSelect)="onDateSelection($event)"
            [displayMonths]="displayMonths"
            [dayTemplate]="t"
            outsideDays="hidden"
            [startDate]="fromDate!"
            tabindex="-1"
            [showWeekNumbers]="weekNumbers"
            [maxDate]="today"
            [class.d-none]="!visible">
          </ngb-datepicker>
          <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.startDate]="isFirstDayRange(date)"
              [class.endDate]="isLastDayRange(date)"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
          </ng-template>
        </div>
        <div class="d-flex datetimepicker-footer tw-flex-col p-2">
          <button *ngIf="allowEmpty" [disabled]="!enableApply " class="btn btn-primary"
                  (click)="clearDate()">{{ 'lang.globals.clear' | translate }}
          </button>
          <div class="tw-flex tw-justify-between tw-mt-1">
            <button class="btn btn-default"
                    (click)="toggleDatepicker()">{{ 'lang.globals.close' | translate }}
            </button>
            <button *ngIf="showSubmit" [disabled]="!enableApply && !allowEmpty" class="btn btn-primary ml-1"
                    (click)="onDateApply()">{{ 'lang.globals.apply' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="fromDate>toDate" class="alert alert-danger"
       style="font-size: .7rem">{{ 'lang.globals.dateWarning'|translate }}
  </div>

</div>
